<a (click)="onClick()" [class]="classes | async">{{ label | humancase }}</a>
